import { useMembership } from '~/techstyle-shared/react-accounts';

import useIsEmpMembership from './useIsEmpMembership';

export default function useEMPPricing(product) {
  const { isEmpMembership } = useIsEmpMembership();
  const { isVip } = useMembership();
  const tokenValue = product
    ? product.tokenRedemptionValue || product.tokenRedemptionQuantity
    : 0;
  const hasTokenValue = Boolean(tokenValue && tokenValue > 0);
  const isTokenOnly =
    product &&
    (product.is_token || product.isToken || product.isTokenOnly) &&
    hasTokenValue &&
    isVip &&
    isEmpMembership;
  const showMemberCredits = hasTokenValue && isVip && isEmpMembership;

  return { showMemberCredits, isTokenOnly, hasTokenValue, tokenValue };
}
